import { Navigate, Outlet } from 'react-router-dom';
import { useFeatureToggles } from 'hooks/useFeatureToggles';

const RequireAgentProfileSettingsLayout = () => {
  const { agentProfileSettings, isLoading } = useFeatureToggles();

  if (isLoading) return null;

  if (!agentProfileSettings) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequireAgentProfileSettingsLayout;
